import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { LanguageService } from './lang';


/**
 * The Alert service shows alerts to the user, and cleans 'em up. On
 * top of that, it also takes care of translations.
 */
@Injectable()
export class AlertService {

  private subject = new Subject<any>();

  constructor(private lang: LanguageService) {
  }

  private _setAlert(message: string, _type: string, persist: boolean) {
    this.lang.translate(message,false).subscribe(
      msg => {
        this.subject.next(
          { type: _type, text: msg, persist: persist || false }
        )
      }
    )
  }

  success(message: string, persist?: boolean) {
    this._setAlert(message, "success", persist || false);
  }

  error(message: string, persist?: boolean) {
    this._setAlert(this.convertMsg(message), "danger", persist || false);
  }

  warn(message: string, persist?: boolean) {
    this._setAlert(this.convertMsg(message), "warning", persist || false);
  }

  info(message: string, persist?: boolean) {
    this._setAlert(message, "info", persist || false);
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  public seen(): void {
    this.subject.next(null);
  }

  private convertMsg(msg) {

    let output = "";

    if (typeof(msg) == 'object') {
      for (let k of Object.keys(msg)) {
        output += `${msg[k]}`;
      }
    } else {
      output = JSON.stringify(msg);
    }
    return output;
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/alert.ts